import { startOfDay, subDays } from 'date-fns';

import {
  ErrorClass,
  type PlatformComponent,
  type PlatformComponentDay,
} from '@/platform-status/entities/platform-component';
import type { TimeBasedPlatformStatus } from '@/platform-status/entities/platform-status';

function goodDay(date: Date): PlatformComponentDay {
  return {
    date: startOfDay(date),
    downtimes: [],
  };
}
function badDay(date: Date): PlatformComponentDay {
  return {
    date: startOfDay(date),
    downtimes: [
      {
        errorClass: ErrorClass.ERROR_CLASS_2,
        durationSec: 1000,
      },
    ],
  };
}
function reallyBadDay(date: Date): PlatformComponentDay {
  return {
    date: startOfDay(date),
    downtimes: [
      {
        errorClass: ErrorClass.ERROR_CLASS_1,
        durationSec: 1000,
      },
    ],
  };
}

export function getTimeBasedPlatformStatus(_: number): TimeBasedPlatformStatus {
  const now = new Date();

  const platformComponents: PlatformComponent[] = [
    {
      id: 'platform',
      name: 'Platform Availability',
      description: undefined,
      uptime: 0.9991,
      activeErrorClass: undefined,
      days: [
        goodDay(subDays(now, 89)),
        goodDay(subDays(now, 88)),
        goodDay(subDays(now, 87)),
        goodDay(subDays(now, 86)),
        goodDay(subDays(now, 85)),
        goodDay(subDays(now, 84)),
        goodDay(subDays(now, 83)),
        goodDay(subDays(now, 82)),
        goodDay(subDays(now, 81)),
        goodDay(subDays(now, 80)),
        goodDay(subDays(now, 79)),
        goodDay(subDays(now, 78)),
        goodDay(subDays(now, 77)),
        goodDay(subDays(now, 76)),
        goodDay(subDays(now, 75)),
        goodDay(subDays(now, 74)),
        goodDay(subDays(now, 73)),
        goodDay(subDays(now, 72)),
        goodDay(subDays(now, 71)),
        goodDay(subDays(now, 70)),
        goodDay(subDays(now, 69)),
        goodDay(subDays(now, 68)),
        goodDay(subDays(now, 67)),
        goodDay(subDays(now, 66)),
        goodDay(subDays(now, 65)),
        goodDay(subDays(now, 64)),
        goodDay(subDays(now, 63)),
        goodDay(subDays(now, 62)),
        goodDay(subDays(now, 61)),
        goodDay(subDays(now, 60)),
        goodDay(subDays(now, 59)),
        goodDay(subDays(now, 58)),
        goodDay(subDays(now, 57)),
        goodDay(subDays(now, 56)),
        goodDay(subDays(now, 55)),
        goodDay(subDays(now, 54)),
        goodDay(subDays(now, 53)),
        goodDay(subDays(now, 52)),
        goodDay(subDays(now, 51)),
        goodDay(subDays(now, 50)),
        goodDay(subDays(now, 49)),
        goodDay(subDays(now, 48)),
        goodDay(subDays(now, 47)),
        goodDay(subDays(now, 46)),
        goodDay(subDays(now, 45)),
        goodDay(subDays(now, 44)),
        goodDay(subDays(now, 43)),
        goodDay(subDays(now, 42)),
        goodDay(subDays(now, 41)),
        goodDay(subDays(now, 40)),
        goodDay(subDays(now, 39)),
        goodDay(subDays(now, 38)),
        goodDay(subDays(now, 37)),
        goodDay(subDays(now, 36)),
        goodDay(subDays(now, 35)),
        goodDay(subDays(now, 34)),
        goodDay(subDays(now, 33)),
        goodDay(subDays(now, 32)),
        goodDay(subDays(now, 31)),
        goodDay(subDays(now, 30)),
        goodDay(subDays(now, 29)),
        goodDay(subDays(now, 28)),
        goodDay(subDays(now, 27)),
        goodDay(subDays(now, 26)),
        goodDay(subDays(now, 25)),
        goodDay(subDays(now, 24)),
        goodDay(subDays(now, 23)),
        goodDay(subDays(now, 22)),
        goodDay(subDays(now, 21)),
        goodDay(subDays(now, 20)),
        goodDay(subDays(now, 19)),
        goodDay(subDays(now, 18)),
        goodDay(subDays(now, 17)),
        goodDay(subDays(now, 16)),
        goodDay(subDays(now, 15)),
        goodDay(subDays(now, 14)),
        goodDay(subDays(now, 13)),
        goodDay(subDays(now, 12)),
        goodDay(subDays(now, 11)),
        goodDay(subDays(now, 10)),
        reallyBadDay(subDays(now, 9)),
        goodDay(subDays(now, 8)),
        goodDay(subDays(now, 7)),
        goodDay(subDays(now, 6)),
        goodDay(subDays(now, 5)),
        badDay(subDays(now, 4)),
        goodDay(subDays(now, 3)),
        goodDay(subDays(now, 2)),
        goodDay(subDays(now, 1)),
        goodDay(now),
      ],
    },
  ];

  return { platformComponents };
}
